module.exports = __webpack_public_path__ + "yz/img/苏宁.d91efff7.jpg";